import React, { FC } from "react";
import { useTranslations } from "next-intl";
import { Button } from "@/components/common";

type Props = {
  openModal: () => void;
  totalPrice: number;
};

const PaymentRequired: FC<Props> = ({ openModal, totalPrice }) => {
  const t = useTranslations();

  return (
    <div className="flex w-full items-center justify-between rounded-[29.5px] bg-[#fceaeb] py-3 pl-8 pr-[6px]">
      <div className="flex flex-col">
        <h2 className="text-[#E53238]">{t("payment_required")}</h2>
        <p className="text-sm font-medium text-[#AF7274]">
          {t("total")}: $ {totalPrice || 0}
        </p>
      </div>
      <Button
        onClick={openModal}
        className="max-w-[124px] !bg-white !text-[#e53238]"
      >
        {t("pay")}
      </Button>
    </div>
  );
};

export default PaymentRequired;
